<template>
  <div class="custom-page-box">
    <a-card title="支付设置" :bordered="false" :headStyle="{fontSize:'18px'}">
      <div class="item-box">
        <img src="../../assets/images/weixin.png">
        <detail-list :col="1" layout="vertical">
          <detail-list-item term="微信支付">
            资金结算时会扣除0.6%支付手续费(微信支付收取)：<a>{{ info.wechatStatus == 1 ? '已开启' : '已关闭' }}</a>
          </detail-list-item>
        </detail-list>
        <a class="right-button" @click="onModifyPassword">修改</a>
      </div>
      <a-divider type="horizontal"></a-divider>
      <div class="item-box">
        <img src="../../assets/images/zhifubao.png">
        <detail-list :col="1" layout="vertical">
          <detail-list-item term="支付宝支付">
            资金结算时会扣除0.6%支付手续费(支付宝收取)：<a>{{ info.alipayStatus == 1 ? '已开启' : '已关闭' }}</a>
          </detail-list-item>
        </detail-list>
        <a class="right-button" @click="onModifyPhoneNumber">修改</a>
      </div>
      <a-divider type="horizontal"></a-divider>
      <div class="item-box">
        <img src="../../assets/images/accounts.png">
        <detail-list :col="1" layout="vertical">
          <detail-list-item term="大额转账">
            线下转账需后台人工审核是否支付，资金结算时会扣除0.6%支付手续费：<a>{{ info.largeTransferstatus == 1 ? '已开启' : '已关闭' }}</a>
          </detail-list-item>
        </detail-list>
        <a class="right-button" @click="onPhoneVerificationSettings">修改</a>
      </div>
      <a-divider type="horizontal"></a-divider>
      <div class="item-box">
        <img src="../../assets/images/balance.png">
        <detail-list :col="1" layout="vertical">
          <detail-list-item term="余额支付">
            用户余额充值金额，可余额完成支付：<a>{{ info.balanceStatus == 1 ? '已开启' : '已关闭' }}</a>
          </detail-list-item>
        </detail-list>
        <a class="right-button" @click="onModifyEmailAddress">修改</a>
      </div>
      <a-divider type="horizontal"></a-divider>
    </a-card>
  </div>
</template>

<script>
import formMixin from '../../utils/mixins/formMixins'
import userHelper from '../../utils/helper/userHelper'
import countDownHelper from '../../utils/helper/countDownHelper'

export default {
  name: 'PaySetting',
  mixins: [formMixin],
  data() {
    return {
      info: ''
    }
  },
  mounted() {
    this.getPayState()
  },
  methods: {
    getPayState() {
      this.getHttpServices().getUserService().post('/api/v2/paySetUp/query/way')
        .then(res => {
          this.info = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onModifyPassword() {
      this.openNewPage('WxPaySetting', {})
    },
    onPhoneVerificationSettings() {
      this.openNewPage('LargeAmountMoneyPaySetting', {})
    },
    onModifyPhoneNumber() {
      this.openNewPage('ZfbPaySetting', {})
    },
    onModifyEmailAddress() {
      this.openNewPage('BalancePaySetting', {})
      //this.$message.warn('该功能正在开发中')
    },

    onNewPasswordChange(e) {
      this.newPassword = e.target.value
    }

  }

}
</script>
<style lang="less" scoped>
@import "../CustomPage";

.item-box {
  position: relative;
  height: 60px;
  width: 100%;
  line-height: 60px;
  padding-left: 90px;

  img {
    display: block;
    width: 70px;
    position: absolute;
    left: 0;
    top: -5px;
  }

  .right-button {
    position: absolute;
    height: 60px;
    line-height: 60px;
    right: 0;
    top: 0;
  }

  .term {
    color: #444444;
    font-weight: bold;
  }
}

.img-code {
  margin-left: 20px;
  width: 130px;
  height: 40px;
}
</style>